<template>
  <v-expansion-panels
    class="mb-4"
  >
    <v-expansion-panel>
      <v-expansion-panel-header> Tìm kiếm báo cáo theo trạng thái</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card class="ma-0 overflow-visible" outlined>
          <validation-observer v-slot="{ handleSubmit }">
            <v-list-item class="pa-0" three-line>
              <v-list-item-content class="overflow-visible pa-0">
                <v-row>
                  <v-col cols="12" md="4">
                    <validation-provider
                      name="Chọn ngày"
                      v-slot="{ errors }"
                      rules="required"
                    >
                      <common-range-picker
                        v-model="selectRange"
                        :clearable="true"
                        :aLight="'right'"
                        :defaultRange="defaultRange"
                        @change-date-range="changeDateRange"
                      />
                      <div class="v-text-field__details mt-1">
                        <div class="v-messages theme--light error--text" role="alert">
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                              {{ errors[0] }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      label="Chọn kho"
                      v-model="filterForm.storeId"
                      :items="storeStocks"
                      item-text="name"
                      item-value="value"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      label="Chọn bộ phận"
                      v-model="filterForm.ministryIds"
                      :items="ministries"
                      item-text="name"
                      item-value="id"
                      value=""
                      multiple
                      clearable
                    >
                      <template #prepend-item>
                        <common-select-all
                          v-model="filterForm.ministryIds"
                          :item="filterForm.ministryIds"
                          :items="ministries.map(s => s.id)"
                        ></common-select-all>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <div class="text-center mb-4">
                  <v-btn
                    class="primary mx-0"
                    @click.prevent="handleSubmit(searchReport);"
                  >
                    <v-icon>mdi-magnify</v-icon>Tìm kiếm
                  </v-btn>
                </div>
              </v-list-item-content>
            </v-list-item>
          </validation-observer>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import TokenService from '../../../../../helpers/token';
import { filterShiftCallCenter } from '../../../../../helpers/constants';
import * as moment from 'moment';
import RepositoryFactory from '../../../../../repositories/RepositoryFactory';
const DepartmentRepository = RepositoryFactory.get('department');

export default {
  props: {
    filterForm: {
      default: () => ({})
    },
    ministries: {
      default: () => {[]}
    }
  },
  data() {
    return {
      filterShiftCallCenter,
      defaultRange: {
        startDate: moment()
          .startOf('days')
          .format('YYYY-MM-DD'),
        endDate: moment()
          .endOf('days')
          .format('YYYY-MM-DD')
      },
      selectRange: [{
        startDate: moment().startOf('day').format('YYYY-MM-DD 00:00:00'),
        endDate: moment().endOf('day').format('YYYY-MM-DD 23:59:59'),
      }],
      departments: [],
      storeStocks: [
        { value: 0, name: 'Tất cả' },
        { value: 2, name: 'Kho T' },
        { value: 1, name: 'Kho C' },
        // { value: 3, name: 'Kho G' }
      ],
    };
  },
  computed: {},
  methods: {
    searchReport() {
      Bus.$emit('status-report-filter', this.filterForm);
    },
    changeDateRange(dateRange) {
      this.filterForm.dateRange = dateRange;
      this.selectRange = dateRange
    }
  }
};
</script>